<template>
  <div id="publicSettingDiv">
    <div class="publicSettingDiv_content">
      <div class="head_title publicSetting_head_title">
        <div class="head_title_font publicSetting_head_title_font">干部教学培训质量评估</div>
      </div>

      <div class="body_content class_body_content">

        <div class="class_body_content_self">
          <table class="table table-striped table-bordered">
            <tr class="tabletrone">
              <td colspan="2">评估内容</td>
              <td>分值</td>
            </tr>
            <tr>
              <td rowspan="3">培训设计（30）</td>
              <td>目标设定</td>
              <td>10</td>
            </tr>
            <tr>
              <td>课程设置</td>
              <td>10</td>
            </tr>
            <tr>
              <td>师资配置</td>
              <td>10</td>
            </tr>

            <tr><td rowspan="3">培训设施（30）</td> <td>教学内容</td> <td>10</td>  </tr>
            <tr> <td>教学方法</td> <td>10</td></tr>
            <tr> <td>教学水平</td> <td>10</td></tr>

            <tr><td rowspan="2">培训管理（20</td> <td>校风教风</td> <td>10</td>  </tr>
            <tr> <td>学员学风及纪律</td> <td>10</td></tr>

            <tr><td rowspan="2">培训效果（20）</td> <td>能力与素质的提升</td> <td>10</td>  </tr>
            <tr> <td>实际工作的帮助</td> <td>10</td></tr>
            <tr> <td colspan="2">总分</td> <td>100</td> </tr>

            <tr><td colspan="3" class="tablelasttd">其他建议:</td></tr>

          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getContentSize} from './mainView';

  export default {
    name: "suggestionsSetting",
    data() {
      return {

      }
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
      });
    },
    methods: {

    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/suggestionSetting.css";
</style>



// WEBPACK FOOTER //
// src/components/suggestionsSetting.vue